import React, { Component } from 'react'
import { connect } from 'react-redux'
import PreAuthCompSample from '../samples/PreAuthCompSample'
import { makePreauthCompletion } from '../../../actions/mcpActions'
import { _DOTNET, _JAVA, _PHP } from '../../../actions/types'

const CODES = {
    store_ID: ["mpgReq.SetStoreId(store_id);", "mpgReq.setStoreId(store_id);", "'store_id'=>$store_id"],
    API_token: ["mpgReq.SetApiToken(api_token);", "mpgReq.setApiToken(api_token);", "'api_token'=>$api_token"],
    
    order_ID: ["mcpCompletion.SetOrderId(order_id);", "mcpCompletion.setOrderId(order_id);", "'order_id'=>$order_id"],
    transaction_number: ["mcpCompletion.SetTxnNumber(txn_number);", "mcpCompletion.setTxnNumber(txn_number);", "'txn_number'=>$txn_number"],
    electronic_commerce_indicator: ["mcpCompletion.SetCryptType(crypt);", "mcpCompletion.setCryptType(crypt);", "'crypt_type'=>$crypt"],
    
    version_number: ["mcpCompletion.SetMCPVersion(\"MCP_VERSION_NUM\");", "mcpCompletion.setMCPVersion(\"MCP_VERSION_NUM\");", "'mcp_version'=> $mcp_version"],
    cardholder_amount: ["mcpCompletion.SetCardholderAmount(\"CARDHOLDER_AMOUNT\");", "mcpCompletion.setCardholderAmount(\"CARDHOLDER_AMOUNT\");", "'cardholder_amount' => $cardholder_amount"],
    cardholder_currency_code: ["mcpCompletion.SetCardholderCurrencyCode(\"CARDHOLDER_CURRENCY_CODE\");", "mcpCompletion.setCardholderCurrencyCode(\"CARDHOLDER_CURRENCY_CODE\");", "'cardholder_currency_code' => $cardholder_currency_code"],

    customer_ID: ["mcpCompletion.SetCustId(cust_id);", "mcpCompletion.setCustId(cust_id);", "'cust_id'=>$cust_id"],
    dynamic_descriptor: ["mcpCompletion.SetDynamicDescriptor(dynamic_descriptor);", "mcpCompletion.setDynamicDescriptor(dynamic_descriptor);", "'dynamic_descriptor'=>$dynamic_descriptor"],

    rate_token: ["mcpCompletion.SetMCPRateToken(\"MCP_RATE_TOKEN\");", "mcpCompletion.setMCPRateToken(\"MCP_RATE_TOKEN\");", "'mcp_rate_token' => $mcp_rate_token"],
}


export class PreAuthCompletion extends Component {
    onMakePreAuthPress() {
        const { storeId, apiToken, orderId, amount, txnNumber, preAuthSuccess, currency, mcpRateToken } = this.props;
        if(preAuthSuccess && txnNumber !== 'none') {
            this.setState({ showErr: false });
            const preAuthCompRequest = { storeId, apiToken, orderId, amount, txnNumber, currency, mcpRateToken };
            this.props.makePreauthCompletion(preAuthCompRequest);
        }
    }

    renderBtn() {
        if(this.props.preAuthSuccess && this.props.txnNumber !== 'none') {
            return (
                <div className="requestButton" onClick={() => this.onMakePreAuthPress()}>
                    MCP Pre-Authorization Completion Request
                </div> 
            );
        }
        else {
            return (
                 <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'left'}}>
                    <div className="disabledButton">
                        MCP Pre-Authorization Completion Request
                    </div> 
                    <i style={{marginLeft: '1vw', fontSize: '0.8rem', color: 'red'}}>* To make this request you need to make a successful Pre-Auth request first.</i>
                </div>
            );
        }
    }

    renderIntegrationTool() {
        return (
            <div className="stepMainContainer">
                <h3>Sample MCP Pre-Authorization Completion</h3>
                <PreAuthCompSample />
                {this.renderBtn()}
            </div>
        );
    }

    renderDocument() {
        const { progLangId } = this.props;

        return (
            <div className="stepPageContainer">
                <span className="stepPageTitle"><b>MCP Pre-Authorization Completion</b></span>
                <p style={{marginTop: '3vh'}}>Retrieves funds that have been locked by an MCP Pre-Authorization transaction, and prepares them for settlement into the merchant’s account.</p>
                <p>This transaction request is the multi-currency pricing (MCP) enabled version of the equivalent financial transaction.</p>

                <p><b>MCP Pre-Authorization Completion transaction object definition</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return  <code>MCPCompletion mcpCompletion = new MCPCompletion();</code>
                    case _JAVA:
                        return <code>MCPCompletion mcpCompletion = new MCPCompletion();</code>
                    case _PHP:
                        return <code>$txnArray = array(‘type’=>’mcp_completion', …);<br />$mpgTxn = new mpgTransaction($txnArray);</code>
                    default:
                        return null
                    }
                })()}

                <p style={{ marginTop: '5vh'}}><b>HttpsPostRequest object for MCP Pre-Authorization Completion transaction</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.SetTransaction(mcpCompletion);</code>
                    case _JAVA:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.setTransaction(mcpCompletion);</code>
                    case _PHP:
                        return <code>$mpgRequest = new mpgRequest($mpgTxn);<br />$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);</code>
                    default:
                        return null
                    }
                })()}

                <h3 style={{ marginTop: '7vh'}}>Core connection object fields (all API transactions)</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>store ID</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.store_ID[progLangId]}</code></td>
                    </tr>

                    <tr>
                        <td>API token</td>
                        <td><i>String</i><br /><br /> N/A</td>
                        <td><code>{CODES.API_token[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>MCP Pre-Authorization Completion transaction request fields – Required</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>order ID</td>
                        <td><i>String</i><br /><br />50-character alphanumeric</td>
                        <td><code>{CODES.order_ID[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>transaction number</td>
                        <td><i>String</i><br /><br />255-character, alphanumeric, hyphens or underscores<br /><br />variable length</td>
                        <td><code>{CODES.transaction_number[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>electronic commerce indicator</td>
                        <td><i>String</i><br /><br />1-character alphanumeric</td>
                        <td><code>{CODES.electronic_commerce_indicator[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>MCP-specific request fields – Required</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>MCP version number</td>
                        <td><i>String</i><br /><br />numeric<br /><br />current version is 1.0</td>
                        <td><code>{CODES.version_number[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>cardholder amount</td>
                        <td><i>String</i><br /><br />12-character numeric<br /><br />smallest discrete unit of foreign currency</td>
                        <td><code>{CODES.cardholder_amount[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>cardholder currency code</td>
                        <td><i>String</i><br /><br />3-character numeric</td>
                        <td><code>{CODES.cardholder_currency_code[progLangId]}</code></td>
                    </tr>
                </table>
                
                <h3 style={{ marginTop: '7vh'}}>MCP Purchase transaction request fields – Optional</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>customer ID</td>
                        <td><i>String</i><br /><br />50-character alphanumeric<p className="note"><b>NOTE: </b> {"Some special characters are not allowed: < > $ % = ? ^ { } [ ] \\"}</p></td>
                        <td><code>{CODES.customer_ID[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>dynamic descriptor<p className="note"><b>NOTE: </b> For Pre-Authorization
                                                                                transactions: the value in the
                                                                                dynamic descriptor field will
                                                                                only be carried over to a Pre-
                                                                                Authorization Completion
                                                                                when executing the latter via
                                                                                the Merchant Resource
                                                                                Center; otherwise, the value for dynamic descriptor must
                                                                                be sent again in the Pre-
                                                                                Authorization Completion</p></td>
                        <td><i>String</i><br /><br />20-character alphanumeric<br /><br />total of 22 characters including your merchant name and separator<p className="note"><b>NOTE: </b> {"Some special characters are not allowed: < > $ % = ? ^ { } [ ] \\"}</p></td>
                        <td><code>{CODES.dynamic_descriptor[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>MCP-specific request fields – Optional</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>MCP rate token</td>
                        <td><i>String</i><br /><br />N/A</td>
                        <td><code>{CODES.rate_token[progLangId]}</code></td>
                    </tr>
                </table>
            </div>
        )
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { storeId, apiToken, orderId, amount, txnNumber, currency, mcpRateToken } = state.mcp.main.config;
    const { preAuthSuccess } = state.mcp.main;
    return { mode, storeId, apiToken, orderId, amount, currency, mcpRateToken, txnNumber, preAuthSuccess, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps, {makePreauthCompletion})(PreAuthCompletion)
